import { Controller } from "@hotwired/stimulus"

// Branch form: shows the owner field when creating a private (developer) branch.
export default class extends Controller {
  static targets = ["type", "ownerGroup"]

  connect() {
    this.typeChanged()
  }

  typeChanged() {
    if (!this.hasTypeTarget || !this.hasOwnerGroupTarget) return
    this.ownerGroupTarget.classList.toggle("hidden", this.typeTarget.value !== "private")
  }
}
